var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('div',{staticClass:"fzr_row"},[_c('div',{staticClass:"fzr_col fzr_12"},[_c('div',{staticClass:"steps"},[_vm._l(([1, 2, 3, 4, 5]),function(i,key){return _c('div',{key:key,staticClass:"number",class:{inverted: i == _vm.step}},[_vm._v(_vm._s(i))])}),_c('div',{staticClass:"line"})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }